import { editorColumns } from "@/mocks/home";

export default function EditorColumn() {
  return (
    <section className="w-full px-4 md:px-8 mt-14 md:mt-20">
      <div className="flex items-center gap-4 mb-6 md:mb-8">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 whitespace-nowrap">
          编辑观察
        </h2>
        <span className="flex-1 h-px bg-background-300/70"></span>
        <span className="hidden sm:inline font-label text-xs text-foreground-400 whitespace-nowrap">
          方法比结论更重要
        </span>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
        {editorColumns.map((col, index) => (
          <article
            key={col.name}
            className={`flex flex-col rounded-lg p-5 md:p-6 border transition-colors ${
              index === 1
                ? "bg-accent-100 border-accent-200"
                : "bg-background-50 border-background-200/80"
            }`}
          >
            <div className="flex items-center gap-3">
              <span
                className={`w-11 h-11 flex items-center justify-center rounded-md font-heading font-bold text-lg ${
                  index === 1
                    ? "bg-accent-500 text-accent-950"
                    : "bg-foreground-950 text-background-50"
                }`}
              >
                {col.avatar}
              </span>
              <span className="flex flex-col">
                <span className="font-heading text-base font-semibold text-foreground-950">
                  {col.name}
                </span>
                <span className="font-label text-xs text-foreground-500">{col.role}</span>
              </span>
            </div>
            <h3 className="mt-5 font-heading text-lg font-semibold leading-snug text-foreground-950">
              {col.title}
            </h3>
            <p className="mt-3 font-label text-sm leading-relaxed text-foreground-600 flex-1">
              {col.excerpt}
            </p>
            <a
              href="#deep"
              className="mt-5 inline-flex items-center gap-1.5 font-label text-xs text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              读这篇观察
              <i className="ri-arrow-right-line text-sm"></i>
            </a>
          </article>
        ))}
      </div>
    </section>
  );
}